module.exports = __webpack_public_path__ + "img/56.6935ce6f.jpg";